import { ArticleLanguageType, DashboardArticle } from './../models/article';
import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { Article, ArticleElement, ArticleFilter, ArticlePreference, ArticleTag, CreateArticle } from '../models/article';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ArticleService extends BaseService<Article> {
  constrollerName: string;
  constructor(public override http: HttpClient) {
    super(http);
    this.constrollerName = 'api/article';
  }

  getTopics(context?: HttpContext): Observable<ArticleTag[]> {
    return this.http.get<ArticleTag[]>(
      `${this.apiUrl}${this.constrollerName}/tags`, { context }
    );
  }

  getElements(): Observable<ArticleElement[]> {
    return this.http.get<ArticleElement[]>(
      `${this.apiUrl}${this.constrollerName}/elements`
    );
  }

  getArticles(articleFilter: ArticleFilter): Observable<Article[]> {
    return this.http.post<Article[]>(
      `${this.apiUrl}${this.constrollerName}/all`, articleFilter
    );
  }

  getArticleForDashboard(articleFilter: ArticleFilter, context?: HttpContext): Observable<DashboardArticle[]> {
    return this.http.post<DashboardArticle[]>(
      `${this.apiUrl}${this.constrollerName}/getArticlesForDashboard`, articleFilter, { context }
    );
  }

  getAuthors(context?: HttpContext): Observable<ArticleElement[]> {
    return this.http.get<ArticleElement[]>(
      `${this.apiUrl}${this.constrollerName}/authors`, { context }
    );
  }

  getArticleByIdForPreview(articleId: number, language: ArticleLanguageType): Observable<Article> {
    return this.http.get<Article>(
      `${this.apiUrl}${this.constrollerName}/getArticleByIdForPreview/${articleId}/language/${language}`
    );
  }

  updateArticle(item: CreateArticle): Observable<Article> {
    return this.http.put<Article>(`${this.apiUrl}${this.constrollerName}`, item);
  }

  publicArticleById(articleId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}${this.constrollerName}/publishArticle/${articleId}`);
  }

  upsertPrefence(articlePrefence: ArticlePreference) {
    return this.http.post<ArticlePreference>(`${this.apiUrl}${this.constrollerName}/preference`, articlePrefence);
  }
}
